import { appleDevice } from "@/lib/utils";

interface navigateLocationProps {
  lat: number;
  long: number;
  children: React.ReactNode;
}

export default function NavigateLocation({
  lat,
  long,
  children,
}: navigateLocationProps) {
  const apple = appleDevice(navigator.userAgent);
  const navigateUrl = apple
    ? `http://maps.apple.com/?ll=${lat},${long}`
    : `https://www.google.com/maps/place/${lat},${long}`;

  const handleNavigation = () => {
    window.open(navigateUrl, "_blank", "noopener,noreferrer");
  };

  return <div onClick={handleNavigation}>{children}</div>;
}
